module.exports = __webpack_public_path__ + "static/img/wrap1.5b968146.png";